import { ConfirmationModal, Typography } from 'seagull';
import { routes } from "../constants";
import ExternalLinkButton from "./ExternalLinkButton";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function TerminateServiceModal(props) {
  const {
    serviceName,
    agreementId,
    stoppageMayAffectNextBill,
    canPauseService,
    onKeepService,
    onStopService
  } = props;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Stop \u201C".concat(serviceName, "\u201D?"),
    skin: "danger",
    "data-testid": "terminate-service-modal",
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "Are you sure you want to stop this service?"
      }), /*#__PURE__*/_jsx(Typography, {
        children: "Your client will no longer be charged for it (we'll let them know)."
      }), stoppageMayAffectNextBill && /*#__PURE__*/_jsx(Typography, {
        children: "If this service was added to the next bill, it will be removed."
      }), canPauseService && /*#__PURE__*/_jsxs(Typography, {
        style: {
          marginBlockStart: 20
        },
        children: ["Note: you may pause the service on the", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
          openInNewTab: true,
          href: routes.billingHub(agreementId),
          children: "billing hub"
        }), "."]
      })]
    }),
    primaryButtonLabel: "Stop service",
    onPrimaryButtonClick: () => onKeepService(),
    secondaryButtonLabel: "Keep service",
    onSecondaryButtonClick: () => onStopService(),
    onCloseButtonClick: () => onStopService()
  });
}